import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-icon',
  imports: [],
  templateUrl: './wallet-icon.html',
  styleUrl: './wallet-icon.scss',
})
export class WalletIcon {

}
